const TAMANHO = /=s\d+(-[a-z0-9-]+)?$/;

/** Pede ao Google a foto já no tamanho da tela; `=s0` é o original e pesa demais. */
export const fotoNoTamanho = (url: string, largura: number): string =>
  TAMANHO.test(url) ? url.replace(TAMANHO, `=s${largura}`) : url;
